import { render, staticRenderFns } from "./PostEditorCheckSheet.vue?vue&type=template&id=55b96cd8&"
import script from "./PostEditorCheckSheet.vue?vue&type=script&lang=js&"
export * from "./PostEditorCheckSheet.vue?vue&type=script&lang=js&"
import style0 from "./PostEditorCheckSheet.vue?vue&type=style&index=0&lang=scss&computed=true&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports